(()=>{
let content,owner,rows=[];
function mount(){
 const candidates=[...document.querySelectorAll('[data-nr-shared-benefits]')];
 const fresh=candidates.find(x=>x!==content);
 if(fresh){rows.forEach(x=>x.remove());if(content)content.remove();content=fresh;owner=fresh.closest('.shopify-section');rows=[...fresh.querySelectorAll('[data-nr-benefit-audience]')];}
 const root=document.querySelector('[data-nr-product-section]'),slot=root?.querySelector('[data-nr-benefits-slot]'),after=root?.querySelector('[data-nr-after-buy-benefits]');
 if(!content||!slot)return;
 slot.append(content);if(owner){owner.hidden=true;owner.style.display='none';}
 rows.forEach(row=>{
 const a=row.dataset.nrBenefitAudience,s=row.dataset.nrBenefitScope;
 row.hidden=(a!=='all'&&s&&s!=='any'&&s!==root.dataset.nrTemplate)||(a==='day'&&root.dataset.nrLens!=='day')||(a==='evening'&&root.dataset.nrLens==='day')||(a==='clipon'&&root.dataset.nrClip!=='true');
 (row.dataset.nrBenefitPosition==='after_buy'&&after?after:content.querySelector('.benefits')).append(row);
 });
 if(after)after.hidden=![...after.children].some(x=>!x.hidden);
}
mount();document.addEventListener('nr:product:change',mount);document.addEventListener('shopify:section:load',mount);
document.addEventListener('shopify:section:select',event=>{if(event.target===owner)content?.scrollIntoView({block:'center',behavior:'auto'});});
document.addEventListener('shopify:block:select',event=>{const row=rows.find(x=>x.contains(event.target)||x===event.target);if(row&&!row.hidden)row.scrollIntoView({block:'center',behavior:'auto'});});
})();
